<h1 mat-dialog-title>
    {{ Title }}
</h1>
<div mat-dialog-content class="dialog-content">
    <p>
        <b>{{Message}}</b>
    </p>
</div>
<div mat-dialog-actions align="end">
    <button id="failed-request-dialog-ok" mat-flat-button
            (click)="OnClickRedirectToLogin()"
            class="btn-sm">
            Okay
    </button>
</div>
